module.exports = __webpack_public_path__ + "static/media/loader.45c8db42.svg";